module.exports = __webpack_public_path__ + "static/media/cases_anuncios_01c.74894155.jpg";